import React from "react";
import { actions, InsuranceCoverageState } from "../store/Insurance";
import { ApplicationState } from "../store";
import { connect } from "react-redux";

import { RadioButtonGroupBase } from "./RadioButtonGroupBase";

const GlassDeductibleSelector: React.FC<InsuranceCoverageProps> = (props: InsuranceCoverageProps) => {
  const currentCoverage = props.Coverages?.find(elem => elem.InternalCode === props.selectedCode);
  const preSelectedDeductible =
    props.SelectedGlassDeductible ?? currentCoverage?.GlassDeductibles?.find((i: any) => i.IsSelected === true)?.Code;

  return (
    <RadioButtonGroupBase
      label={{ title: props.ui?.glassDeductible?.label }}
      help={{ title: props.ui?.glassDeductible?.helpHeader, description: props.ui?.glassDeductible?.helpText }}
      selected={preSelectedDeductible}
      id='glassSkada'
      onChange={props.insuranceGlassDeductibleChanged}
      values={currentCoverage?.GlassDeductibles?.map(i => {
        return {
          value: i.Code,
          title: i.Name,
        };
      })}
    />
  );
};

const connector = connect((state: ApplicationState) => state.insurance?.coverage, {
  insuranceGlassDeductibleChanged: actions.insuranceGlassDeductibleChanged,
});

type InsuranceCoverageProps = InsuranceCoverageState & { insuranceGlassDeductibleChanged: Function };

export default connector(GlassDeductibleSelector);
